import React from "react";
import { Flex, Text } from "rebass";

import { RampingControl } from "./components/RampingControl";
import { SpeedControl } from "./components/SpeedControl";
import { VoiceControl } from "./components/VoiceControl";

export function Route() {
  return (
    <Flex
      height="100%"
      flexDirection="column"
      p="65px 100px 35px"
    >
      <Text
        as="h3"
        mb="30px"
        color="#2b3160"
        fontSize="30px"
        fontWeight="bold"
        lineHeight={1.07}
      >
        Listening
      </Text>

      <VoiceControl />

      <SpeedControl />

      <RampingControl />
    </Flex>
  );
}
